import { StyleSheet } from 'aphrodite';
import { background, darkGrayFontColor, mention, nameCircles, navigation, white } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		background: white,
		border: `1px solid ${nameCircles}`,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.10)',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: '27px 30px',
		textAlign: 'center',
	},
	controlsContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
		width: '100%',
	},
	enabledIndicator: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		fontSize: 12,
		justifyContent: 'center',
		letterSpacing: '1.1px',
		width: 80,
		...CssSelectors.allChildren(
			{
				color: darkGrayFontColor,
				marginLeft: 10,
			},
			'span'
		),
	},
	iconContainer: {
		alignItems: 'flex-end',
		display: 'flex',
		height: 40,
		justifyContent: 'center',
		...CssSelectors.allChildren({
			maxHeight: '100%',
		}),
	},
	manageCta: {
		marginLeft: 10,
	},
	dropdownContainer: {
		position: 'relative',
		display: 'inline-block',
	},
	dropdownButton: {
		width: '100%',
	},
	chevronIcon: {
		marginLeft: 5,
		width: 12,
		height: 12,
	},
	dropdownMenuUp: {
		position: 'absolute',
		backgroundColor: white,
		minWidth: 120,
		boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
		zIndex: 1,
		borderRadius: 4,
		border: `1px solid ${nameCircles}`,
		bottom: 'calc(100% + 2px)',
		right: 0,
	},
	dropdownMenuDown: {
		position: 'absolute',
		backgroundColor: white,
		minWidth: 120,
		boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
		zIndex: 1,
		borderRadius: 4,
		border: `1px solid ${nameCircles}`,
		top: 'calc(100% + 2px)',
		right: 0,
	},
	dropdownMenuItem: {
		color: 'black',
		padding: '10px 16px',
		textDecoration: 'none',
		display: 'block',
		textAlign: 'left',
		border: 'none',
		background: 'none',
		cursor: 'pointer',
		width: '100%',
		fontSize: 14,
		':hover': {
			backgroundColor: background,
		},
	},
	numLeadsParsedContainer: {
		boxSizing: 'border-box',
		color: navigation,
		fontSize: 12,
		height: 30,
		paddingTop: 5,
	},
	tag: {
		background: mention,
		borderRadius: 20,
		fontSize: 12,
		margin: '0 4px',
		padding: '4px 20px',
		width: 'auto',
	},
	tagsContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexGrow: 'unset',
		justifyContent: 'center',
	},
});
